<template>
    <v-col cols="12" class="MyRequest mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                    <h2 class="font-weight-medium">Tus Solicitudes de Venta de Energía</h2>
                    <h6 class="font-weight-regular">Tienes 4 solicitudes de venta de energía. <a  href="#">Actualiza tu plan</a> para ver quienes son los interesados</h6>
                    <v-row align="center" class="caption">
                         <v-col cols="12" lg="5" class="d-flex align-center">
                             <v-btn text><v-icon>mdi-dip-switch</v-icon> Filtros</v-btn>
                            <span>Ver: </span>
                            <v-btn text>Todas <v-icon color="green">mdi-check-box-outline</v-icon></v-btn>
                            <v-btn text>Aprobadas <v-icon>mdi-check-box-outline</v-icon></v-btn>
                            <v-btn text>Rechazadas <v-icon>mdi-check-box-outline</v-icon></v-btn>
                        </v-col>   
                         
                         <v-spacer></v-spacer>
                         <v-col cols="12" lg="5" class="d-flex align-center justify-end">
                            <span>Vista </span>
                            <v-btn icon @click="viewMode = 'table'" class="" tile large :color="viewMode == 'table' ? 'blue' : 'grey'" dense icon>
                                <v-icon>mdi-view-list</v-icon>
                            </v-btn>
                            <v-btn icon @click="viewMode = 'card'" class="" tile large :color="viewMode == 'card' ? 'blue' : 'grey'" dense icon>
                                <v-icon>mdi-view-grid</v-icon>
                            </v-btn>
                            <v-text-field
                                    class="buscador tipo1"
                                    placeholder="Buscar en"
                                    outlined
                                    append-icon="mdi-magnify"
                            ></v-text-field>
                            <v-btn color="primary"
                                raised
                                dark
                                to="/system/payment/my-plan/"
                                class="text-capitalize spa px-6">
                                Actualizar Plan</v-btn>
                         </v-col>
                    </v-row>

                    <v-row v-if="viewMode == 'table'">
                                     <v-data-table
                                                :headers="closings.headers"
                                                :items="closings.data"
                                                item-key="code"
                                                :item-class="classColorReturn"
                                                :items-per-page="5"
                                                class="elevation-1"
                                                :search="closings.search"
                                                dense
                                                show-select
                                        >


                                            <template v-slot:item.code="{ item }">
                                                {{ item.code }}
                                                <v-progress-linear value="10"></v-progress-linear>
                                            </template>
                                            <template v-slot:item.TimeBlocks="{ item }">
                                                <v-col class="d-inline-flex">
                                                    <v-chip v-for="(block,key) in item.TimeBlocks"
                                                            class="ma-1 "
                                                            :color="block === 'A' ? '#004E85': block === 'B' ? '#FF9A1B' : block === 'C' ? '#0172C0' : 'grey'  "
                                                            label
                                                            :key="item.code+'-'+key"
                                                            dense
                                                            small
                                                            text-color="white"
                                                    >
                                                        {{block}}
                                                    </v-chip>
                                                </v-col>
                                            </template>
                                            <template v-slot:item.GeneratorResponse="{ item }">
                                                <v-icon color="green" v-if="item.GeneratorResponse === true">
                                                    mdi-check-box-outline
                                                </v-icon>
                                                <v-icon color="red" v-if="item.GeneratorResponse === false">
                                                    mdi-close-box-outline
                                                </v-icon>
                                                <v-icon color="grey" v-if="item.GeneratorResponse === null">
                                                    mdi-checkbox-blank-outline
                                                </v-icon>
                                            </template>
                                            <template v-slot:item.ContractClosing="{ item }">
                                                <v-icon color="green" v-if="item.ContractClosing === true">
                                                    mdi-check-box-outline
                                                </v-icon>
                                                <v-icon color="red" v-if="item.ContractClosing === false">
                                                    mdi-close-box-outline
                                                </v-icon>
                                                <v-icon color="grey" v-if="item.ContractClosing === null">
                                                    mdi-checkbox-blank-outline
                                                </v-icon>
                                            </template>
                                            <template v-slot:item.SupplierInfo="{ item }">
                                                <v-col class="d-inline-flex">
                                                    <v-icon color="grey">
                                                        mdi-clock-time-four-outline
                                                    </v-icon>
                                                    <v-icon color="grey">
                                                        mdi-information-outline
                                                    </v-icon>
                                                </v-col>
                                            </template>
                                            <template v-slot:item.Manage="{ item }">
                                                <v-btn 
                                                raised
                                                :color="item.Manage.color"
                                                small
                                                dark
                                                class="">{{item.Manage.text}}</v-btn>
                                            </template>

                                        </v-data-table>
                                </v-row>
                    <v-row v-else-if="viewMode == 'card'">
                        <div v-for="(request, key) in requests" :key="'col-card-request-'+key">
                            <v-card :key="'card-request-'+key"
                                    class="outline-0 card-max-width py-6 px-3 text-center overflow-hidden rounded-xl"
                                    color="#FFF">

                                <v-img
                                        :class="request.status === 'locked-plan' ? 'mx-auto blur' : 'mx-auto'"
                                        max-width="70%"
                                        alt="Neocity Logo"
                                        src="@/assets/images/neocity-logo.png"
                                        contain
                                ></v-img>
                                <v-col class="mx-auto" cols="8">
                                    <b>
                                        A - 1000
                                        X. Los Lagos, 220Kv
                                        +50 MW
                                    </b>
                                </v-col>

                                <div class="mx-auto">
                                    <v-chip
                                            class="ma-2"
                                            color="#004E85"
                                            label
                                            text-color="white"
                                    >
                                        A
                                    </v-chip>
                                    <v-chip
                                            class="ma-2"
                                            color="#FF9A1B"
                                            label
                                            text-color="white"
                                    >
                                        B
                                    </v-chip>
                                    <v-chip
                                            class="ma-2"
                                            color="#0172C0"
                                            label
                                            text-color="white"
                                    >
                                        C
                                    </v-chip>
                                </div>
                                <div class="mx-auto">
                                    <b>6 Meses</b>
                                </div>

                                    <b>Precio: <span class="green--text">30 USD/MWh</span></b>
                                <v-rating
                                        :value="'4'"
                                        readonly
                                        background-color="orange lighten-3"
                                        color="orange"
                                        >

                                </v-rating>
                                <v-progress-linear height="10px"
                                                   :color="request.progress <= 35 ? 'green' : request.progress <= 70 ? 'orange' : request.progress < 100 ? 'red' :'grey' "
                                                   :value="request.progress"></v-progress-linear>
                                <v-col v-if="request.status === 'locked-plan'">
                                    <p><a href="#" @click="dialog.updatePlan.show = true" class="text-decoration-none">Actualiza tu plan</a>
                                        para ver quienes son los interesados
                                    </p>
                                </v-col>
                                <template v-else>
                                    <v-row>
                                        <v-col>
                                            <v-btn  @click="dialog.validateClient.show = true" class="ma-2" tile large :color="request.status === 'approved' ? 'green': 'grey'" dense icon>
                                                <v-icon>mdi-check-box-outline</v-icon>
                                            </v-btn>
                                            <h6>Aprobar Cliente</h6>
                                        </v-col>
                                        <v-col>
                                            <v-btn  @click="dialog.validateClient.show = true" class="ma-2" tile large :color="request.status === 'rejected' ? 'red': 'grey'" dense icon>
                                                <v-icon>mdi-close-box-outline</v-icon>
                                            </v-btn>
                                            <h6>Rechazar Cliente</h6>
                                        </v-col>
                                    </v-row>
                                    <div v-if="request.status === 'approved'" style="
                                    width: 0;
                                    right: 0;
                                    height: 0;
                                    border-style: solid;
                                    border-width: 0 60px 60px 0;
                                    border-color: transparent green transparent transparent;
                                    text-align: right;
                                    position: absolute;
                                    top: 0;"
                                    >
                                        <v-icon
                                                style=" margin-left: 30px; margin-top: 5px"
                                                color="white">mdi-check</v-icon>
                                    </div>
                                    <div v-else-if="request.status === 'rejected'" style="
                                    width: 0;
                                    right: 0;
                                    height: 0;
                                    border-style: solid;
                                    border-width: 0 60px 60px 0;
                                    border-color: transparent red transparent transparent;
                                    text-align: right;
                                    position: absolute;
                                    top: 0;"
                                    >
                                        <v-icon
                                                style=" margin-left: 30px; margin-top: 5px"
                                                color="white">mdi-close</v-icon>
                                    </div>
                                </template>

                                <a href="#"  @click="dialog.viewDetails.show = true" class="text-decoration-none">Ver detalles [ + ]</a>
                            </v-card>
                        </div>

                    </v-row>
                </v-card>
            </v-col>
        </v-row>



            <v-card style="position: fixed; top:40px; z-index: 999; left: 45vw" height="150" width="150" color="orange" dark class="mx-auto text-center rounded-circle d-inline-flex align-center justify-center">
                <v-col class="text-center">
                    <h5 class="font-weight-medium">Has vendido</h5>
                    <h3 class="font-weight-bold">350 GWh</h3>
                    <h5 class="font-weight-medium">de tus 500GWh
                        disponibles</h5>

                </v-col>
            </v-card>


        <!--Update view details-->
        <v-dialog
                v-model="dialog.viewDetails.show"
                width="80%"
        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    Detalle del Comprador
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-card
                                    class="pa-3 elevation-0"
                                    color="#F5F5F5"
                            >
                                <v-row>
                                    <v-col cols="2">
                                        <v-card
                                                color="#FFFFFF"
                                                class="pa-4 ma-0 elevation-1"
                                                tile
                                                height="150px"
                                                width="150px"
                                        >
                                            <v-img src="@/assets/images/neocity-logo.png"
                                                   height="130px"
                                                   width="130px"
                                                   aspect-ratio="2"
                                                   contain>
                                            </v-img>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="6">
                                        <b>Neocity Energía</b>
                                        <p class="caption">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque blandit accumsan libero, facilisis interdum turpis rutrum vitae.
                                            Duis sit amet libero vitae ligula placerat hendrerit at quis massa. Nam vulputate pretium odio mattis rutrum. n sit amet efficitur urna.
                                            Phasellus vitae tempor magna. Etiam id pharetra ipsum. Curabitur id efficitur erat.
                                        </p>
                                        <v-btn color="primary"
                                               raised
                                               outlined
                                               class="px-6 mt-5">
                                            Ver detalles Empresa</v-btn>
                                    </v-col>
                                    <v-col cols="4">

                                        <v-card
                                                class="outline-0 py-6 px-3 text-center overflow-hidden"
                                                color="#FFFFFF">

                                            <v-col class="mx-auto" cols="8">
                                                <b>
                                                    A - 1000
                                                    X. Los Lagos, 220Kv
                                                    +50 MW
                                                </b>
                                            </v-col>

                                            <div class="mx-auto">
                                                <v-chip
                                                        class="ma-2"
                                                        color="#004E85"
                                                        label
                                                        text-color="white"
                                                >
                                                    A
                                                </v-chip>
                                                <v-chip
                                                        class="ma-2"
                                                        color="#FF9A1B"
                                                        label
                                                        text-color="white"
                                                >
                                                    B
                                                </v-chip>
                                                <v-chip
                                                        class="ma-2"
                                                        color="#0172C0"
                                                        label
                                                        text-color="white"
                                                >
                                                    C
                                                </v-chip>
                                            </div>
                                            <div class="mx-auto">
                                                <b>6 Meses</b>
                                            </div>

                                            <b>Precio: <span class="green--text">30 USD/MWh</span></b>
                                            <v-rating
                                                    :value="'4'"
                                                    readonly
                                                    background-color="orange lighten-3"
                                                    color="orange"
                                                    class="pb-5"
                                            >

                                            </v-rating>
                                        </v-card>

                                    </v-col>
                                </v-row>

                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="8" class="mx-auto text-center">
                            Algunos graficos
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="red"
                            raised
                            dark
                            @click="dialog.viewDetails.show = false"
                    >
                        Rechazar Solicitud
                    </v-btn>
                    <v-btn
                            color="primary"
                            raised
                            dark
                            @click="dialog.viewDetails.show = false"
                    >
                        Aprobar Solicitud
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Update validate Client-->
        <v-dialog
                v-model="dialog.validateClient.show"
                width="60%"
        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    <v-icon color="orange" size="60">mdi-information-outline</v-icon>Importante: Lee con atención
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="mx-auto text-center">
                            <v-card
                                    class="pa-3 elevation-0"

                            >
                                <v-row class="text-left">
                                    <v-col cols="2">

                                            <v-img src="@/assets/images/neocity-logo.png"
                                                   height="130px"
                                                   width="130px"
                                                   aspect-ratio="2"
                                                   contain>
                                            </v-img>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-row class="caption">
                                            <v-col cols="12">
                                                <b>NEOCITY ENERGÍA - 76.859.223-7</b>
                                            </v-col>
                                        </v-row>
                                        <v-row class="caption">
                                            <v-col class="py-0">Nombre de Fantasía</v-col>
                                            <v-col class="py-0">Nombre de la empresa S.A</v-col>
                                        </v-row>
                                        <v-row class="caption">
                                            <v-col class="py-0">Giro Comercial</v-col>
                                            <v-col class="py-0">Energía</v-col>
                                        </v-row>
                                        <v-row class="caption">
                                            <v-col class="py-0">Direccion Comercial</v-col>
                                            <v-col class="py-0">Los militares 8659</v-col>
                                        </v-row>
                                        <v-row class="caption">
                                            <v-col class="py-0">Representante Legal</v-col>
                                            <v-col class="py-0">Marcos Cisternas</v-col>
                                        </v-row>
                                        <v-row class="caption">
                                            <v-col class="py-0">Sitio Web</v-col>
                                            <v-col class="py-0">www.neocity.cl</v-col>
                                        </v-row>

                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                        <b>Propuesta de Contrato </b>
                                        <v-img
                                                src="@/assets/images/pdf.png"
                                                height="100px"
                                                contain
                                        >
                                        </v-img>
                                        <a href="#" class="text-underline"> Descargar Contrato</a>
                                    </v-col>
                                </v-row>

                            </v-card>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="12" class="mx-auto text-center">
                            <v-card
                                    class="pa-3 elevation-0"

                            >
                                <v-row class="text-left">
                                    <v-col cols="2">

                                            <v-img src="@/assets/images/neocity-logo.png"
                                                   height="130px"
                                                   width="130px"
                                                   aspect-ratio="2"
                                                   contain>
                                            </v-img>
                                    </v-col>
                                    <v-col cols="9">
                                        <v-row class="caption">
                                            <v-col cols="12">
                                                <b>COSTO POR SERVICIOS</b>
                                            </v-col>
                                        </v-row>
                                        <v-row class="caption">
                                            <v-col class="py-0">COMISIÓN DE CIERRE (NEOCITY) $120.000
                                            </v-col>
                                        </v-row>
                                        <v-row class="caption">
                                            <v-col class="py-0"><a href="#" class="text-decoration-none">Beneficios Neocity</a></v-col>
                                        </v-row>
                                        <v-row class="caption">
                                            <v-col class="py-0"> <v-icon color="green"> mdi-check </v-icon> Menos Tiempo</v-col>
                                        </v-row>
                                        <v-row class="caption">
                                            <v-col class="py-0"> <v-icon color="green"> mdi-check </v-icon> Automático</v-col>
                                        </v-row>
                                        <v-row class="caption">
                                            <v-col class="py-0">  <v-icon color="green"> mdi-check </v-icon> Más Simple</v-col>
                                        </v-row>

                                    </v-col>
                                </v-row>

                            </v-card>

                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-row>
                        <v-col cols="8" class="mx-auto text-center">
                            <p>¿Estás seguro que quieres enviar esta solicitud?</p>
                        </v-col>
                        <v-col cols="12" class="justify-center">
                            <div class="text-center">
                                <v-btn
                                        class="mx-4"
                                        color="red"
                                        raised
                                        dark
                                        @click="dialog.validateClient.show = false"
                                >
                                    NO
                                </v-btn>
                                <v-btn
                                        color="primary"
                                        raised
                                        dark
                                        @click="dialog.validateClient.show = false"
                                >
                                    si
                                </v-btn>
                            </div>

                        </v-col>
                    </v-row>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-col>
</template>
<style>
    .blur {
        -webkit-filter: blur(5px);
        -moz-filter: blur(5px);
        -o-filter: blur(5px);
        -ms-filter: blur(5px);
        filter: blur(5px);
    }
</style>
<script>
    export default {
        name: 'MyRequest',
        data() {
            return {
                viewMode:'card',
                  closings:{
                    search:'',
                    headers: [
                        { text: 'Código', value: 'code' },
                        { text: 'Suministrador', value: 'supplier' },
                        { text: 'Precio Energia (USD/MWh)', value: 'EnergyPrice' },
                        { text: 'Precio Potencia (USD/MW-mes', value: 'PricePower' },
                        { text: 'Cuenta Mensual (USD)', value: 'MonthlyAccount' },
                        { text: 'Periodo de suministro (Meses)', value: 'SupplyPeriod' },
                        { text: 'Bloques Horarios', value: 'TimeBlocks' },
                        { text: 'Tipo de Tecnoloigia', value: 'TypeOfTechnology' },
                        { text: 'Respuesta Generador', value: 'GeneratorResponse', class:'rotateTh' },
                        { text: 'Cierre del contrato', value: 'ContractClosing' , class:'rotateTh'},
                        { text: 'Cierre del contrato', value: 'ContractClosing' , class:'rotateTh'},
                        { text: 'Info del Suministrador', value: 'SupplierInfo' , class:'rotateTh'},
                        { text: 'Diferencia (USD)', value: 'DifferenceUSD' },

                    ],
                    data: [
                        {
                            color:'',
                            code: 'A-1000',
                            supplier: 'San Andres SpA',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                          
                        },
                        {
                            color:'',
                            code: 'A-1002',
                            supplier: 'San Andres SpA',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                           
                        },
                        {
                            color:'blue lighten-5',
                            code: 'A-1003',
                            supplier: 'San Andres SpA',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                           
                        },
                        {
                            color:'red lighten-5',
                            code: 'A-1004',
                            supplier: 'San Andres SpA',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                           
                        },
                        {
                            color:'grey lighten-3',
                            code: 'A-1005',
                            supplier: 'San Andres SpA',
                            EnergyPrice:'30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: 6,
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:null,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                           
                        },
                    ],
                },
                dialog:{
                    viewDetails:{ show: false },
                    validateClient:{ show: false },
                },
                search:'',
                filter:{

                },
                requests:[
                    {
                        rating:3,
                        status:'locked-plan',
                        progress:60
                    },
                    {
                        rating:3,
                        status:'pending',
                        progress:90

                    },
                    {
                        rating:5,
                        status:'pending',
                        progress:30

                    },
                    {
                        rating:4,
                        status:'approved',
                        progress:100

                    },
                    {
                        rating:4,
                        status:'rejected',
                        progress:100

                    },
                ]
            }
        },
        created: function () {
            this.$emit('SetcolorMenu', 'primary');
        }
    }
</script>